module.exports = __webpack_public_path__ + "static/media/logo-innovate.ebe4e0ce.svg";